/*
 GLOBAL FUNCTIONALITY:
 */

gliv = {
	init: function(){
		$html = document.getElementsByTagName('html')[0];
		gliv.cE();
	},
	cE: function cacheElements(){
		gliv.el();
	},
	el: function eventListenters(){
		/**
		 CLICK EVENT FOR PRINT BUTTON ON ALL SAVINGS CARD PAGES
		 **/
		$(".cta-print").on("click", function(evt){
			window.print();
			evt.preventDefault();
		});

		// avoids loading video content for mobile users
		if (!gliv.isMobile()){
			if ($('body').hasClass('switch-statins')){
				$('#statin-videobg').html('<source src="/assets/video/DTC_Exam_Cinemagraph.mp4" type="video/mp4">');
			}
		}
	},
	checkHashes: function(){
		if(window.location.hash.length > 0) {
			window.setTimeout(function(){
				switch(window.location.hash) {
					case "#pooled":
						$('[data-section="#trial-data-why"]').click();
						break;
				}
			}, 1500);

		}
	},
	returnWindowWidth: function(){
		return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth);
	},
	returnWindowHeight: function(){
		return (window.screen.height || window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight);
	},
	returnScrollTop: function(){
		return (window.scrollY || document.documentElement.scrollTop);
	},
	getElDimension: function(el, includeBorder) {
		var
			$el = (typeof el === 'string') ? document.querySelector(el) : el,
			w   = 0,
			h   = 0;
		if (includeBorder) {
			w = $el.offsetWidth;
			h = $el.offsetHeight;
		} else {
			w = $el.clientWidth;
			h = $el.clientHeight;
		}
		return {width: w, height: h};
	},
	isMobile: function () {
		return ( navigator.userAgent.match(/Android/i)
			|| navigator.userAgent.match(/webOS/i)
			|| navigator.userAgent.match(/iPhone/i)
			|| navigator.userAgent.match(/iPad/i)
			|| navigator.userAgent.match(/iPod/i)
			|| navigator.userAgent.match(/BlackBerry/i)
			|| navigator.userAgent.match(/Windows Phone/i)
		);
	},
	addCookie: function(name, value, days){
		var cookieAge = 60 * 60 * 24 * days;
		document.cookie= name+"="+value+";max-age="+cookieAge+";path=/";
	},
	checkCookie: function(cookieName){
		var cookies = document.cookie.match('(^|[^;]+)\\s*' + cookieName + '\\s*=\\s*([^;]+)');
		return cookies ? cookies.pop() : '';
	}
};
